import { render, staticRenderFns } from "./SimAppDetail.vue?vue&type=template&id=27780888&scoped=true&"
import script from "./SimAppDetail.vue?vue&type=script&lang=js&"
export * from "./SimAppDetail.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/appstore-simform.css?vue&type=style&index=0&id=27780888&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27780888",
  null
  
)

export default component.exports